import { PercentageHalfCircleChart } from '@/components/ui/chart';

export interface QuizPercentageResultProps {
  attemptScore: number | undefined | null;
  maxScore: number;
}

export default function QuizPercentageResult(quizPercentageResultProps: QuizPercentageResultProps) {
  const { attemptScore, maxScore } = quizPercentageResultProps;
  const percentage: number = attemptScore ? (attemptScore * 100) / maxScore : NaN;

  return (
    <div className="mx-auto max-w-72 min-w-40">
      <PercentageHalfCircleChart percentage={percentage} />
      <div className="inline-flex w-full items-center justify-center gap-4">
        <div className="flex flex-col items-center gap-1 text-center">
          <span className="text-text-tertiary text-xs">Punkty</span>
          <span>{attemptScore != undefined ? `${attemptScore} / ${maxScore}` : '-'}</span>
        </div>
      </div>
    </div>
  );
}
